import React from "react";
import { NavLink } from "react-router-dom";
import { Home, BarChart3, Package, MoreHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BottomNavigationMobileProps {
  onOpenDrawer: () => void;
}

const mainNavItems = [
  { path: "/dashboard", icon: Home, label: "Dashboard" },
  { path: "/dashboard/google-analytics", icon: BarChart3, label: "Analytics" },
  { path: "/dashboard/products", icon: Package, label: "Produtos" },
];

export const BottomNavigationMobile: React.FC<BottomNavigationMobileProps> = ({
  onOpenDrawer,
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background border-t border-border lg:hidden">
      <div className="flex items-center justify-around h-16 px-2">
        {mainNavItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                cn(
                  "flex flex-col items-center justify-center flex-1 h-full transition-colors",
                  isActive
                    ? "text-[#2869C1]"
                    : "text-muted-foreground hover:text-foreground",
                )
              }
            >
              <Icon className="h-5 w-5 mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </NavLink>
          );
        })}

        <Button
          variant="ghost"
          size="sm"
          onClick={onOpenDrawer}
          className="flex flex-col items-center justify-center flex-1 h-full text-muted-foreground hover:text-foreground"
        >
          <MoreHorizontal className="h-5 w-5 mb-1" />
          <span className="text-xs font-medium">Mais</span>
        </Button>
      </div>
    </div>
  );
};
